import { useEffect } from "react"
export default function Sitemap() {
    useEffect(() => {
        window.location.href.push("https://api.busiknow.com/sitemap.xml")
    }, [])
    return <>

    </>
}